import React from 'react';
import MDKPIApproval from './Report_Performance';
import '../../../CommonCSS/SocietyCSS.css';

const MD_KPI_ApprApp = () => {
  return (

    <div className="app-wrapper">
      <div className="form-container">
        <div className='card' style={{borderRadius: '8px'}}>
          <div className="card-header-css" style={{borderRadius: '8px', textAlign: 'center' }} >
            <h5>Performance KPI Report</h5>
          </div>
        </div>
        <MDKPIApproval/>
      </div>
    </div >
  );
};

export default MD_KPI_ApprApp;
